import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import cookie from 'react-cookies';
import { toast } from 'react-toastify';
import {hideModalPageClass} from '../../functions';

export default class ModalPaginas extends Component {
    constructor(props) {

        super(props); 

        this.state = {
            resource: [],
            response: [],
            error: [],
            security: cookie.load('user'),
            roles: [],
            filters:{
                texto:''
            },
          }

        this.handleInputChange = this.handleInputChange.bind(this);
    }
    

      handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.filters;
        copyResource[target.name] = value;

        this.setState({
            filters: copyResource
        });     
    }

    retornarURL = (url = "") => {        
        this.props.callback(url);    
        
        hideModalPageClass();
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionButton(e);
        }
    }

    callFunctionButton = (event) => {

        var textoFilter = this.state.filters.texto;

        if(textoFilter == ""){
            this.setState({filters:{texto: textoFilter}, resource: []});
            return;
        }

        this.setState({filters:{texto: textoFilter}});

        const url = `${API_URL}PaginaUX/BuscarPaginas/${textoFilter}`

        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ resource: data.result, response: data, error: data.Error});
        })
        .catch(error => {
            toast.error('Error de comunicación');
        });
    }

    render() {
        return (
            <div className={"divModalPagina " + this.props.class} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_ModalPaginas" onClick={() => hideModalPageClass()}/>
                    <h2>Modal de Paginas Internas </h2>
                    <div className="divWrapperModalPaginas">
                        <div className="divSearchModalPaginas">
                            <input type="text" placeholder="Buscar una página..." name="texto" id="titulo_pagina" onKeyDown={this._handleKeyDown} onChange={this.handleInputChange}/>
                            <input type="submit" defaultValue="Buscar" onClick={(event) => this.callFunctionButton(event)}/>
                        </div>
                        {
                            this.state.resource.length > 0 ?
                            <div className="divScroll">
                                <div className="divListadoModalPaginas scrollgeneral ">
                                    <ul>
                                        {
                                            this.state.resource.map((page) => (
                                                <li><span>{page.pagi_Titulo}</span> <a href="" className="noneEvent" data-enlace={page.pagi_Enlace} onClick={() => this.retornarURL(page.pagi_Enlace)}>Asignar</a></li>
                                            ))
                                        }                           
                                    </ul>
                                </div>
                            </div>
                            : null
                        }
                    </div>
                    </div>
                </div>
                </div>

        )
    }
}
